import { render, staticRenderFns } from "./close-tab.vue?vue&type=template&id=9dc1e744&"
import script from "./close-tab.vue?vue&type=script&lang=js&"
export * from "./close-tab.vue?vue&type=script&lang=js&"
import style0 from "./close-tab.vue?vue&type=style&index=0&id=9dc1e744&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports